<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" background-color="#FFFFFF" color="#005f32"
      spinner="bar-fade-scale" />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex>
        <!-- <v-card> -->
        <v-card-title class="elevation-0">
          <v-flex xs12 align-self-center pt-2>
            <v-layout wrap justify-start>
              <v-flex xs12 text-left>
                <span style="font-family: kumbhRegular; font-size: 14px">*Select the options to filter the
                  results</span>
              </v-flex>
              <v-flex xl3 lg3 md3 pb-2 sm6 xs12 pl-0 pl-xs-0 pl-sm-1 pl-md-1 pl-lg-1 pl-xl-1 pr-0 pr-xs-0 pr-sm-2
                pr-md-2 pr-lg-2 pr-xl-2>
                <v-select :items="lists" dense hide-details v-model="status" item-text="name" item-value="value" outlined
                  class="rounded-xl"></v-select>
              </v-flex>

              <v-flex xl3 lg3 md3 pb-2 sm6 xs12 px-0 px-xs-0 px-sm-2 px-md-2 px-lg-2 px-xl-2>
                <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition"
                  offset-y max-width="290px" min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedDateFormatted" outlined hide-details dense class="rounded-xl"
                      v-bind="attrs" v-on="on" clearable></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title type="month" @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xl3 lg3 md3 pb-2 sm6 xs12 px-0 px-xs-0 px-sm-2 px-md-2 px-lg-2 px-xl-2>
                <v-text-field v-model="employeeName" outlined hide-details dense class="rounded-xl" placeholder="Search" clearable></v-text-field>
              </v-flex>
              <v-flex xl3 lg3 md3 pb-2 sm6 xs12 px-0 px-xs-0 px-sm-2 px-md-2 px-lg-2 px-xl-2>
                <v-btn
                  style="background-color: #005f32; color: white; border-radius: 24px; text-transform: none; height: 40px;"
                  @click="exportToExcel"
                  elevation="2"
                >
                  <v-icon left color="white" small class="mr-1">mdi-download</v-icon> Export
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-title>

        <v-layout wrap justify-start px-5 v-if="leaveArray.length > 0">
          <v-flex xs12>
            <v-simple-table class="align-center">
              <template v-slot:default>
                <thead style="background-color: #005f32">
                  <tr>
                    <th style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        " class="text-left">
                      Employee ID
                    </th>
                    <th style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        " class="text-left">
                      Employee Name
                    </th>
                    <th style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        " class="text-left">
                      Leave Category
                    </th>
                    <th style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        " class="text-left">
                      Applied Date
                    </th>
                    <th style="
    font-size: 15px;
    color: #ffffff;
    font-family: kumbhRegular;
  " class="text-left">
                      Date Applied
                    </th>
                    <th style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        " class="text-left">
                      Day(s)
                    </th>
                    <!-- <th style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        " class="text-left">
                      Remaining Leaves
                    </th> -->
                    <th style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        " class="text-left">
                      Status
                    </th>
                    <th style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        " class="text-left">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody class="align-center">
                  <tr class="text-left align-center" v-for="(item, i) in leaveArray" :key="i">
                    <td>
                      <span v-if="item.uid" class="" style="font-family: kumbhMedium">{{ item.uid.employeeId }}</span>
                    </td>
                    <td>
                      <span v-if="item.uid" class="" style="font-family: kumbhMedium">{{ item.uid.name }}</span>
                    </td>
                    <td>
                      <span v-if="item.leaveCategory" class="" style="font-family: kumbhMedium">
                        <template v-if="item.festivalRequiredOn && item.festivalRequiredOn.length > 0 && item.leaveCategory !== 'Festival'">
                          {{ item.leaveCategory }} + Festival
                        </template>
                        <template v-else>
                          {{ item.leaveCategory }}
                        </template>
                      </span>
                    </td>

                    <td>
                      <span v-if="item.create_date" class="" style="font-family: kumbhMedium">{{
                        formatDate(item.create_date) }}</span>
                    </td>
                    <td>
  <span
    v-if="item.leaveRequiredOn && item.leaveRequiredOn.length"
    class=""
    style="font-family: kumbhMedium"
    >{{ formatLeaveDates(item.leaveRequiredOn) }}</span
  >
</td>
                    <td>
                      <span v-if="item.leaveRequiredOn" class="" style="font-family: kumbhMedium">{{
                        item.leaveRequiredOn.length }}</span>
                    </td>
                    <!-- <td>
                      <span v-if="item.userLeaveDetailsId.leaveDetails[0].remaining" class=""
                        style="font-family: kumbhMedium">{{ item.userLeaveDetailsId.leaveDetails[0].remaining }}</span>
                    </td> -->
                    <td>
                      <span v-if="item.status" class="" style="font-family: kumbhMedium">{{ item.status }}</span>
                    </td>
                    <td>
                      <v-layout wrap>
                        <v-flex xs12 align-self-center text-left pa-2>
                          <router-link :to="'/Attendance/leaveRequestsDetails?id=' + item._id
                            ">
                            <v-icon title="View" color="#005f32">mdi-eye</v-icon>
                          </router-link>
                        </v-flex>
                      </v-layout>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>
        <v-layout wrap v-else>
          <v-flex xs12 align-self-center pa-16>
            <span class="kumbhRegular">No Data found!</span>
          </v-flex>
        </v-layout>
        <!-- </v-card> -->
      </v-flex>
    </v-layout>

    <v-layout wrap justify-center v-if="pages > 1">
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination prev-icon="mdi-menu-left" next-icon="mdi-menu-right" :length="pages" :total-visible="7"
            v-model="currentPage" color="#005f32"></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import * as XLSX from "xlsx";
export default {
  data: (vm) => ({
    showsnackbar: false,
    ServerError: false,
    msg: null,
    pages: 0,
    dialog: false,
    pageCount: 1,
    appLoading: false,
    currentPage: 1,
    g: false,
    totalData: 0,
    addcat: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    status: "",
    lists: [
      {
        name: "All",
        value: "",
      },
      { name: "Pending", value: "pending" },
      { name: "Approved", value: "approved" },
      { name: "Rejected", value: "rejected" },
      { name: "Withdrawn", value: "withdrawn" },
    ],
    leaveArray: [],
    data: [],
    name: null,
    assetId: null,
    date: new Date().toISOString().substr(0, 7),
    dateFormatted: vm.formatDateMonth(new Date().toISOString().substr(0, 7)),
    computedDateFormatted: "",
    menu1: false,
    menu2: false,
    employeeName: "",
  }),
  created() {
    if (this.$route && this.$route.query) {
      const q = this.$route.query;
      const querySearch = q.search || q.name || q.empname || q.employeeName;
      if (querySearch) {
        this.employeeName = querySearch;
      }
      if (q.page) {
        const p = parseInt(q.page, 10);
        if (p > 0) this.currentPage = p;
      }
      if (q.status) {
        this.status = q.status;
      }
      if (q.month) {
        this.date = q.month;
      }
    }
  },
  // computed: {
  //   computedDateFormatted () {
  //     return this.formatDateMonth(this.date)
  //   },
  // },
  beforeMount() {
    this.computedDateFormatted = this.formatDateMonth(this.date);
    this.getData();
  },
  beforeDestroy() {
    if (this._queryTimeout) clearTimeout(this._queryTimeout);
  },
  watch: {
    '$route.query': {
      handler(newQuery) {
        if (newQuery && (newQuery.search || newQuery.name || newQuery.empname || newQuery.employeeName)) {
          const queryVal = newQuery.search || newQuery.name || newQuery.empname || newQuery.employeeName;
          if (this.employeeName !== queryVal) {
            this.employeeName = queryVal;
          }
        }
      },
      immediate: true
    },
    date() {
      this.currentPage = 1;
      this.computedDateFormatted = this.formatDateMonth(this.date);
      if (this.computedDateFormatted) {
        this.getData();
        this.$store.commit("changeDate", this.date);
        this.updateQuery();
      }
    },
    status() {
      this.currentPage = 1;
      this.getData();
      this.$store.commit("changeStatus", this.status);
      this.updateQuery();
    },
    currentPage() {
      this.getData();
      this.updateQuery();
    },
    employeeName() {
      this.currentPage = 1;
      this.getData();
      this.updateQuery();
    },
  },

  methods: {
    updateQuery() {
      // The layout's <router-view :key="$route.fullPath"> remounts the whole
      // page whenever the query string changes, so this must be debounced -
      // otherwise every keystroke in the search box remounts the page and
      // the input loses focus mid-type.
      if (this._queryTimeout) clearTimeout(this._queryTimeout);
      this._queryTimeout = setTimeout(() => {
        const query = {};
        if (this.currentPage > 1) query.page = String(this.currentPage);
        if (this.status) query.status = this.status;
        if (this.date) query.month = this.date;
        if (this.employeeName) query.search = this.employeeName;
        this.$router.replace({ query }).catch(() => {});
      }, 600);
    },
    async exportToExcel() {
      this.appLoading = true;
      try {
        const response = await axios({
          url: "/employee/leave/application/list",
          method: "POST",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          data: {
            page: 1,
            limit: this.totalData > 0 ? this.totalData : 1000,
            month: this.computedDateFormatted,
            status: this.status,
            employeeName: this.employeeName,
          },
        });
        
        let data = response.data.data;
        const excelData = data.map(item => ({
          "Employee ID": item.uid ? item.uid.employeeId : '',
          "Employee Name": item.uid ? item.uid.name : '',
          "Leave Category": item.festivalRequiredOn && item.festivalRequiredOn.length > 0 && item.leaveCategory !== 'Festival' ? item.leaveCategory + ' + Festival' : (item.leaveCategory ? item.leaveCategory : ''),
          "Applied Date": item.create_date ? this.formatDate(item.create_date) : '',
          "Date Applied": item.leaveRequiredOn ? this.formatLeaveDates(item.leaveRequiredOn) : '',
          "Day(s)": item.leaveRequiredOn ? item.leaveRequiredOn.length : 0,
          "Status": item.status ? item.status : ''
        }));
        
        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Leave Requests");
        XLSX.writeFile(workbook, "Leave_Requests.xlsx");
      } catch (err) {
        console.error(err);
      } finally {
        this.appLoading = false;
      }
    },
    getData() {
      this.appLoading = true;
      //   if (this.date !== "") {
      //     this.date= this.formatDateMonth(this.date);
      //   }
      //   if (this.formatDateMonth(this.date) === "1-1970") {
      //     this.date = null;
      //   }
      axios({
        url: "/employee/leave/application/list",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          page: this.currentPage,
          limit: 20,
          month: this.computedDateFormatted,
          status: this.status,
          employeeName: this.employeeName,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.leaveArray = response.data.data;
          this.totalData = response.data.totalLength;
          this.pages = Math.ceil(this.totalData / response.data.limit);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
    formatLeaveDates(dates) {
    if (!dates || !dates.length) return '';
    return dates
      .map(dateStr => {
        const dt = new Date(dateStr);
        // Format as DD-MM-YYYY or as you prefer
        const day = String(dt.getDate()).padStart(2, '0');
        const month = String(dt.getMonth() + 1).padStart(2, '0');
        const year = dt.getFullYear();
        return `${day}-${month}-${year}`;
      })
      .join(', ');
  },
    formatDateMonth(date) {
      if (!date) return null;
      const [year, month] = date.split("-");
      return `${month}-${year}`;
    },
  },
};
</script>
<style>
.tableHead {
  font-size: 15px;
  color: #ffffff;
  font-family: kumbhMedium;
}
</style>